import { AccountCircle } from "@mui/icons-material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import PersonIcon from "@mui/icons-material/Person";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import {
  Box,
  Button,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Stack,
  Typography,
} from "@mui/material";

import React, { useCallback, useEffect, useState } from "react";
// import CloudIcon from "@mui/icons-material/Cloud";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import AudioFileIcon from "@mui/icons-material/AudioFile";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import DescriptionIcon from "@mui/icons-material/Description";
import FolderIcon from "@mui/icons-material/Folder";
import FolderOpenOutlinedIcon from "@mui/icons-material/FolderOpenOutlined";
import ImageIcon from "@mui/icons-material/Image";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import MovieIcon from "@mui/icons-material/Movie";
import PeopleAltRoundedIcon from "@mui/icons-material/PeopleAltRounded";
import PermIdentityOutlinedIcon from "@mui/icons-material/PermIdentityOutlined";
import SearchIcon from "@mui/icons-material/Search";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { useUserProfile } from "../context/UserProfileContext";
import { useUser } from "../hooks/Authorize";
import { useTheme } from "../style/theme";
const Filters = ({
  leftImg,
  selectedFilters,
  setSelectedFilters,
  setClikkleItems,
}) => {
  const platformUser = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();
  const location = useLocation();
  const [sharedWithPeople, setSharedWithPeople] = useState([]);
  const [dynamicLocation, setDynamicLocation] = useState(null);
  const { mode } = useTheme();

  const [anchorEls, setAnchorEls] = useState({
    type: null,
    people: null,
    modified: null,
    source: null,
  });
  const [personSubmenuAnchorEl, setPersonSubmenuAnchorEl] = useState(null);
  const [submenuPersonData, setSubmenuPersonData] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");

  const filteredPeople = sharedWithPeople.filter(
    (person) =>
      person.firstName.toLowerCase().includes(searchQuery.toLowerCase()) ||
      person.lastName.toLowerCase().includes(searchQuery.toLowerCase()) ||
      person.email.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const { fsUserProfile, setFsUserProfile } = useUserProfile();
  const [userTotalSpacePlan, setUserTotalSpacePlan] = useState(null);
  const [isLoadingProfile, setIsLoadingProfile] = useState(false);
  const [isLoadingSubscription, setIsLoadingSubscription] = useState(false);

  const getFsUserProfile = useCallback(async () => {
    try {
      setIsLoadingProfile(true);
      const response = await axios.get(
        `${process.env.REACT_APP_NODE_FILE_MANAGER_SERVER}/api/user/${platformUser._id}`
      );
      setFsUserProfile(response.data);
      console.log("setFsUserProfile = ", response.data);
    } catch (error) {
      console.error("Profile Fetch Error:", error);
    } finally {
      setIsLoadingProfile(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const checkSubscriptionDetails = useCallback(async () => {
    try {
      setIsLoadingSubscription(true);
      const response = await axios.get(
        `${process.env.REACT_APP_NODE_FILE_MANAGER_SERVER}/api/subscription/${platformUser._id}`
      );

      const data = response.data;
      setUserTotalSpacePlan(data?.permissions);
    } catch (error) {
      console.log("API Error:", error?.response?.data);
    } finally {
      setIsLoadingSubscription(false);
    }
  }, [platformUser._id]);

  const isLoading = isLoadingProfile || isLoadingSubscription;

  useEffect(() => {
    getFsUserProfile();
    checkSubscriptionDetails();
  }, [getFsUserProfile, checkSubscriptionDetails]);

  // const BYTES_IN_GB = 1073741824;

  // const noOfAllowed = userTotalSpacePlan?.noOfAllowed ?? 0;
  // const format = userTotalSpacePlan?.format ?? "GB";
  // const isUnlimited = userTotalSpacePlan?.isUnlimited ?? false;

  // // If space is unlimited, no need to calculate limit
  // let TOTAL_SPACE_GB = 0;
  // let percentageUsed = 0;
  // let isSpaceFull80 = false;

  // if (!isUnlimited) {
  //   TOTAL_SPACE_GB =
  //     format === "TB" ? noOfAllowed * 1024 : format === "GB" ? noOfAllowed : 0;

  //   const usedBytes = fsUserProfile?.usedSpace ?? 0;
  //   const usedGB = usedBytes / BYTES_IN_GB;

  //   percentageUsed = (usedGB / TOTAL_SPACE_GB) * 100;
  //   isSpaceFull80 = percentageUsed >= 80;
  // }

  // if (!isUnlimited) {
  //   if (format === "TB") {
  //     TOTAL_SPACE_GB = noOfAllowed * 1024;
  //   } else if (format === "GB") {
  //     TOTAL_SPACE_GB = noOfAllowed;
  //   } else if (format === "MB") {
  //     TOTAL_SPACE_GB = noOfAllowed / 1024; // Convert MB to GB
  //   } else {
  //     TOTAL_SPACE_GB = 0;
  //   }

  //   const usedBytes = fsUserProfile?.usedSpace ?? 0;
  //   const usedGB = usedBytes / BYTES_IN_GB;

  //   percentageUsed = (usedGB / TOTAL_SPACE_GB) * 100;
  //   isSpaceFull80 = percentageUsed >= 80;
  // }

  const BYTES_IN_GB = 1073741824;
  const BYTES_IN_MB = 1048576;

  const noOfAllowed = userTotalSpacePlan?.noOfAllowed ?? 5;
  const format = userTotalSpacePlan?.format ?? "GB";
  const isUnlimited = userTotalSpacePlan?.isUnlimited ?? false;

  let TOTAL_SPACE_GB = 0;
  let percentageUsed = 0;
  let isSpaceFull80 = false;

  if (!isUnlimited) {
    if (format === "TB") {
      TOTAL_SPACE_GB = noOfAllowed * 1024; // TB to GB
      const usedBytes = fsUserProfile?.usedSpace ?? 0;
      const usedGB = usedBytes / BYTES_IN_GB;
      percentageUsed = (usedGB / TOTAL_SPACE_GB) * 100;
    } else if (format === "GB") {
      TOTAL_SPACE_GB = noOfAllowed;
      const usedBytes = fsUserProfile?.usedSpace ?? 0;
      const usedGB = usedBytes / BYTES_IN_GB;
      percentageUsed = (usedGB / TOTAL_SPACE_GB) * 100;
    } else if (format === "MB") {
      TOTAL_SPACE_GB = noOfAllowed; // Keep it as MB for MB format
      const usedBytes = fsUserProfile?.usedSpace ?? 0;
      const usedMB = usedBytes / BYTES_IN_MB;
      percentageUsed = (usedMB / TOTAL_SPACE_GB) * 100;
    }

    isSpaceFull80 = percentageUsed >= 80;
  }

  const [isSpaceFull80ModalOpen, setIsSpaceFull80ModalOpen] = useState(false);
  useEffect(() => {
    if (isSpaceFull80) {
      setIsSpaceFull80ModalOpen(true);
    } else {
      setIsSpaceFull80ModalOpen(false);
    }
  }, [isSpaceFull80]);

  const handleBuyStorage = () => {
    const redirectUrl = process.env.REACT_APP_STORE_REDIRECT_URL;
    if (redirectUrl) {
      window.open(redirectUrl, "_blank");
    } else {
      console.error("Redirect URL not defined");
    }
  };
  useEffect(() => {
    // console.log('-> apply filters');
    const fetchData = async () => {
      try {
        const urlParams = new URLSearchParams(location.search);
        const params = new URLSearchParams({
          ownerId: platformUser._id,
        });

        // Add all active filters to params
        if (selectedFilters.location) {
          const locationValue = urlParams.get("location");
          if (locationValue) {
            params.set("parentId", locationValue);
          }
        }

        if (selectedFilters.type) {
          params.set("type", selectedFilters.type);
        }

        if (selectedFilters.people) {
          console.log("selectedFilters.people = ", selectedFilters.people);
          params.set("sharedWithEmail", selectedFilters.people.email);
          params.set("sharedWithPermissionType", selectedFilters.people.access);
        }

        if (selectedFilters.modified) {
          params.set("modified", selectedFilters.modified);
        }

        // Add filter box filters if they exist in URL
        // const urlParams = new URLSearchParams(location.search);
        // if (urlParams.get('people_id')) params.set('targetUserId', urlParams.get('people_id'));
        if (urlParams.get("q_type"))
          params.set("type", urlParams.get("q_type"));
        if (urlParams.get("q_type"))
          params.set("type", urlParams.get("q_type"));
        if (urlParams.get("q_ownerType"))
          params.set("ownerType", urlParams.get("q_ownerType"));
        if (urlParams.get("q_specificOwner"))
          params.set("specificOwner", urlParams.get("q_specificOwner"));
        if (urlParams.get("q_itemName"))
          params.set("itemName", urlParams.get("q_itemName"));
        if (urlParams.get("q_location"))
          params.set("location", urlParams.get("q_location"));
        if (urlParams.get("q_dateModified"))
          params.set("dateModified", urlParams.get("q_dateModified"));
        if (urlParams.get("q_dateFrom"))
          params.set("dateFrom", urlParams.get("q_dateFrom"));
        if (urlParams.get("q_dateTo"))
          params.set("dateTo", urlParams.get("q_dateTo"));

        // const url = `${process.env.REACT_APP_NODE_FILE_MANAGER_SERVER}/api/fs?${params.toString()}`;
        // const response = await axios.get(url);
        // setClikkleItems(response.data);
        // console.log('API response:', response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    selectedFilters.location,
    selectedFilters.type,
    selectedFilters.people,
    selectedFilters.modified,
    location.search,
  ]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_NODE_FILE_MANAGER_SERVER}/api/fs/shared-user-data?userId=${platformUser._id}`
        );
        setSharedWithPeople(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const newFilters = { ...selectedFilters };

    // Initialize location filter
    if (params.has("location")) {
      const locationValue = params.get("location");
      const locationName = params.get("locationName");

      if (locationValue === "my_drive") {
        newFilters.location = "My Files";
      } else if (locationValue === "shared_with_me") {
        newFilters.location = "Shared Drives";
      } else if (locationName) {
        newFilters.location = decodeURIComponent(locationName);
        setDynamicLocation({
          label: decodeURIComponent(locationName),
          value: locationValue,
          icon: <FolderIcon />,
        });
      }
    }

    // Initialize type filter
    if (params.has("type")) {
      newFilters.type = params.get("type");
    }

    // Initialize modified filter
    if (params.has("modified")) {
      const modifiedValue = params.get("modified");
      const modifiedOption = filters.modified.find(
        (f) => f.value === modifiedValue
      );
      if (modifiedOption) {
        newFilters.modified = modifiedOption.label;
      }
    }

    // Initialize people filter
    // Initialize people filter
    if (params.has("people")) {
      // Handle "anyone-with-link" case
      newFilters.people = "Anyone with Link";
    } else if (params.has("people_email") && params.has("people_access")) {
      newFilters.people = {
        _id: params.get("people_id"),
        email: params.get("people_email"),
        access: params.get("people_access"),
        display: `${params.get("people_email")} - ${params.get(
          "people_access"
        )}`,
      };
    }

    setSelectedFilters(newFilters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  const handleMenuOpen = (event, category) => {
    setAnchorEls({ ...anchorEls, [category]: event.currentTarget });
  };

  const handleMenuClose = (category) => {
    setAnchorEls({ ...anchorEls, [category]: null });
  };

  const updateURL = (newFilters) => {
    const searchParams = new URLSearchParams(location.search);
    console.log("location.search = ", location.search);
    console.log("people_id = ", searchParams.get("people_id"));
    // Preserve all q_* parameters from filter box
    const qParams = {};
    if (searchParams.get("people_id")) {
      qParams["people_id"] = searchParams.get("people_id");
    }
    searchParams.forEach((value, key) => {
      if (key.startsWith("q_")) {
        qParams[key] = value;
      }
    });

    if (searchParams.get("parentId")) {
      qParams.parentId = searchParams.get("parentId");
    }

    // Clear all non-q_ parameters
    searchParams.forEach((value, key) => {
      if (!key.startsWith("q_")) {
        searchParams.delete(key);
      }
    });

    // Add all active filters to URL
    Object.entries(newFilters).forEach(([key, value]) => {
      if (value) {
        // Clean up old people filters if applying a new people filter
        if (key === "people") {
          // Remove all existing people-related parameters
          ["people_email", "people_access", "people_id"].forEach((param) => {
            searchParams.delete(param);
          });

          if (typeof value === "object") {
            // For object-type people filter (specific person)
            searchParams.set("people_email", value.email);
            searchParams.set("people_access", value.access);
            if (value._id) searchParams.set("people_id", value._id);
          } else {
            // For string-type people filter (e.g., "anyone-with-link")
            searchParams.set(
              "people",
              value.toLowerCase().replace(/\s+/g, "-")
            );
          }
        } else if (key === "modified") {
          const filter = filters.modified.find((f) => f.label === value);
          if (filter) searchParams.set(key, filter.value);
        } else if (key === "location") {
          const filter = filters.location.find((f) => f.label === value);
          if (filter) {
            searchParams.set(key, filter.value);
            if (
              filter.value !== "my_drive" &&
              filter.value !== "shared_with_me"
            ) {
              searchParams.set("locationName", filter.label);
            }
          }
        } else {
          searchParams.set(key, value.replace(/\s+/g, "-"));
          // searchParams.set(key, value.toLowerCase().replace(/\s+/g, '-'));
        }
      }
    });

    // Re-add preserved q_* parameters
    Object.entries(qParams).forEach(([key, value]) => {
      searchParams.set(key, value);
    });

    navigate({
      pathname: location.pathname,
      search: searchParams.toString(),
    });
  };
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const newFilters = {};

    // Initialize filters from URL
    Object.keys(filters).forEach((category) => {
      if (category === "modified") {
        const value = params.get(category);
        if (value) {
          const filter = filters.modified.find((f) => f.value === value);
          if (filter) newFilters[category] = filter.label;
        }
      } else if (category === "location") {
        const value = params.get(category);
        if (value) {
          const filter = filters.location.find((f) => f.value === value);
          if (filter) newFilters[category] = filter.label;
        }
      } else if (category === "people") {
        const email = params.get(`${category}_email`);
        const access = params.get(`${category}_access`);
        if (email && access) {
          newFilters[category] = {
            email,
            access,
            display: `${email} - ${access}`,
          };
        }
      } else {
        const value = params.get(category);
        if (value) newFilters[category] = value;
      }
    });

    setSelectedFilters((prev) => ({ ...prev, ...newFilters }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  const handleFilterSelect = (category, value) => {
    const newFilters = { ...selectedFilters, [category]: value };

    if (category === "location") {
      const searchParams = new URLSearchParams();
      const filter = filters.location.find((f) => f.label === value);

      if (filter) {
        // Set the selected location in URL
        searchParams.set("location", filter.value);
        if (filter.value !== "my_drive" && filter.value !== "shared_with_me") {
          searchParams.set("locationName", filter.label);
        }

        // Preserve other active filters including full people object
        Object.entries(selectedFilters).forEach(([key, val]) => {
          if (key !== "location" && val) {
            if (key === "people" && typeof val === "object") {
              searchParams.set(`${key}_email`, val.email);
              searchParams.set(`${key}_access`, val.access);
              if (val._id) searchParams.set(`${key}_id`, val._id);
            } else {
              // searchParams.set(key, val.replace(/\s+/g, '-'));
              searchParams.set(key, val.toLowerCase().replace(/\s+/g, "-"));
            }
          }
        });

        navigate({ search: searchParams.toString() });
      }
    } else {
      updateURL(newFilters);
    }

    setSelectedFilters(newFilters);
    handleMenuClose(category);
  };
  const handleFilterClear = async (category) => {
    const newFilters = { ...selectedFilters, [category]: null };
    setSelectedFilters(newFilters);

    const searchParams = new URLSearchParams(location.search);
    // Preserve q_* parameters
    const qParams = {};
    searchParams.forEach((value, key) => {
      if (key.startsWith("q_")) {
        qParams[key] = value;
      }
    });

    // Clear the specific filter
    if (category === "location") {
      searchParams.delete("location");
      searchParams.delete("locationName");
    } else if (category === "people") {
      searchParams.delete("people");
      searchParams.delete("people_id");
      searchParams.delete("people_email");
      searchParams.delete("people_access");
      // await fetchResources({});
    } else {
      searchParams.delete(category);
    }

    // Re-add preserved q_* parameters
    Object.entries(qParams).forEach(([key, value]) => {
      searchParams.set(key, value);
    });

    navigate({ search: searchParams.toString() });
  };

  const handlePersonClick = (event, person) => {
    setPersonSubmenuAnchorEl(event.currentTarget);
    setSubmenuPersonData(person);
  };

  const handleSubmenuClose = () => {
    setPersonSubmenuAnchorEl(null);
    setSubmenuPersonData(null);
  };

  const onClickPeopleFilterAnyoneWithLink = async () => {
    handleFilterSelect("people", "Anyone with Link");
    await fetchResources({ generalAccess: "Anyone" });
  };

  const onClickPeopleAccessOption = async (option) => {
    var payload = {
      email: submenuPersonData.email,
      _id: submenuPersonData._id,

      access: option,
      display: `${submenuPersonData.firstName} ${submenuPersonData.lastName} - ${option}`,
    };
    handleFilterSelect("people", payload);
    handleSubmenuClose();
    await fetchResources({
      people: {
        _id: submenuPersonData._id,
        email: submenuPersonData.email,
        access: option,
        display: `${submenuPersonData.firstName} ${submenuPersonData.lastName} - ${option}`,
      },
    });
  };

  const fetchResources = async (payload) => {
    // console.log('payload.people = ',payload.people)
    // try {
    //   var url = `${process.env.REACT_APP_NODE_FILE_MANAGER_SERVER}/api/fs?ownerId=${platformUser._id}`
    //   if (payload.generalAccess) {
    //     url += `&generalAccess=Anyone`
    //   }
    //   if (payload.people?.email) {
    //     url += `&sharedWithEmail=${payload.people.email}&sharedWithPermissionType=${payload.people?.access}&targetUserId=${payload.people?._id}`
    //   }
    //   console.log('payload = ', payload.people)
    //   const response = await axios.get(url, payload);
    //   // setSharedWithPeople(response.data);
    //   setClikkleItems(response.data);
    // } catch (error) {
    //   console.error("Error fetching data:", error);
    // }
  };

  const filters = React.useMemo(() => {
    const params = new URLSearchParams(location.search);
    const locationValue = params.get("location");
    const locationName = params.get("locationName");
    const baseLocationFilters = [
      { label: "My Files", icon: <PersonIcon />, value: "my_drive" },
      {
        label: "Shared Drives",
        icon: <PeopleAltRoundedIcon />,
        value: "shared_with_me",
      },
    ];
    // Add dynamic location if exists in URL and isn't a standard location
    if (
      locationValue &&
      locationName &&
      locationValue !== "my_drive" &&
      locationValue !== "shared_with_me"
    ) {
      baseLocationFilters.push({
        label: decodeURIComponent(locationName),
        value: locationValue,
        icon: <FolderIcon />,
      });
    }
    const baseFilters = {
      type: [
        {
          label: "Document",
          icon: <DescriptionIcon style={{ color: "#2196f3" }} />,
          value: "Document",
        },
        {
          label: "Folder",
          icon: <FolderIcon style={{ color: "#ffca28" }} />,
          value: "Folder",
        },
        {
          label: "Image",
          icon: <ImageIcon style={{ color: "#f44336" }} />,
          value: "Image",
        },
        {
          label: "Video",
          icon: <MovieIcon style={{ color: "#4caf50" }} />,
          value: "Video",
        },
        {
          label: "Audio",
          icon: <AudioFileIcon style={{ color: "#9c27b0" }} />,
          value: "Audio",
        },
      ],
      people: [
        {
          label: "Me",
          icon: <PersonIcon style={{ color: "#2196f3" }} />,
          name: "Rishabh Raj Tarun",
          email: "rishabh@clikkle.com",
          value: "me",
        },
        {
          label: "Assigned to me",
          icon: <PersonIcon style={{ color: "#4caf50" }} />,
          name: "John Doe",
          email: "john.doe@example.com",
          value: "assigned",
        },
        {
          label: "Owned by me",
          icon: <PersonIcon style={{ color: "#ffc107" }} />,
          name: "Alice Smith",
          email: "alice.smith@example.com",
          value: "owned",
        },
        {
          label: "Collaborator",
          icon: <PersonIcon style={{ color: "#673ab7" }} />,
          name: "Mark Johnson",
          email: "mark.johnson@example.com",
          value: "collaborator",
        },
      ],
      modified: [
        { label: "Today", icon: <AccessTimeIcon />, value: "today" },
        { label: "Last 7 days", icon: <AccessTimeIcon />, value: "last_7" },
        { label: "Last 30 days", icon: <AccessTimeIcon />, value: "last_30" },
        { label: "Last 90 days", icon: <AccessTimeIcon />, value: "last_90" },
      ],
      location: baseLocationFilters,
    };

    return baseFilters;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dynamicLocation]);

  const showIcon = (type) => {
    switch (type) {
      case "type":
        return <InsertDriveFileOutlinedIcon />;
      case "people":
        return <PermIdentityOutlinedIcon />;
      case "modified":
        return <CalendarTodayOutlinedIcon />;
      case "location":
        return <FolderOpenOutlinedIcon />;
      default:
        return;
    }
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          gap: 2,
          flexWrap: "wrap",
          paddingLeft: 2.5,
        }}
      >
        {Object.keys(filters).map((category) => (
          <Box key={category}>
            <Button
              variant="outlined"
              startIcon={
                selectedFilters[category] || !leftImg
                  ? null
                  : showIcon(category)
              }
              endIcon={selectedFilters[category] ? null : <ArrowDropDownIcon />}
              onClick={(e) => handleMenuOpen(e, category)}
              sx={{
                height: 40,
                minWidth: 120,
                borderRadius: 6,
                backgroundColor: selectedFilters[category]
                  ? "#3767b1"
                  : "custom.search.main",
                color: selectedFilters[category] ? "white" : "#757575",
                borderColor: "transparent",
                display: "flex",
                justifyContent: selectedFilters[category]
                  ? "space-between"
                  : "center",
                alignItems: "center",
                padding: selectedFilters[category] ? 0 : "0 16px",
                "&:hover": {
                  // backgroundColor: "custom.search.main",
                  // boxShadow: "0px 4px 15px 0px rgba(0, 0, 0, 0.25)",
                  background:
                    mode === "dark" ? "custom.search.focus" : "#3767b120",

                  borderColor: "transparent",
                },
              }}
            >
              {selectedFilters[category] ? (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    flex: 1,
                    height: "100%",
                  }}
                >
                  <Box
                    sx={{
                      padding: "0 10px",
                      flex: 1,
                      display: "flex",
                      alignItems: "center",
                      borderRight: "1px solid #ccc",
                      height: "100%",
                    }}
                  >
                    {typeof selectedFilters[category] === "object"
                      ? selectedFilters[category].display
                      : selectedFilters[category]}
                  </Box>
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleFilterClear(category);
                    }}
                    sx={{
                      height: "100%",
                      borderRadius: 0,
                      padding: "0 10px",
                      color: "white",
                      backgroundColor: "transparent",
                      "&:hover": {
                        backgroundColor: "transparent",
                      },
                    }}
                  >
                    <CloseIcon fontSize="small" />
                  </IconButton>
                </Box>
              ) : (
                category.charAt(0).toUpperCase() + category.slice(1)
              )}
            </Button>
            <Menu
              anchorEl={anchorEls[category]}
              open={Boolean(anchorEls[category])}
              onClose={() => handleMenuClose(category)}
            >
              {category === "location"
                ? filters.location.map((filter) => {
                    const isActive = selectedFilters.location === filter.label;
                    return (
                      <MenuItem
                        key={filter.value}
                        onClick={() =>
                          handleFilterSelect("location", filter.label)
                        }
                        sx={{
                          backgroundColor: isActive
                            ? "rgba(25, 118, 210, 0.08)"
                            : "inherit",
                          "&:hover": {
                            backgroundColor: "rgba(0, 0, 0, 0.04)",
                          },
                        }}
                      >
                        <ListItemIcon>{filter.icon}</ListItemIcon>
                        <ListItemText
                          primary={filter.label}
                          primaryTypographyProps={{
                            fontWeight: isActive ? "bold" : "normal",
                          }}
                        />
                        {isActive && (
                          <CheckIcon color="primary" sx={{ ml: 1 }} />
                        )}
                      </MenuItem>
                    );
                  })
                : category !== "people" &&
                  filters[category].map((filter) => (
                    <MenuItem
                      key={filter.value}
                      onClick={() => handleFilterSelect(category, filter.label)}
                    >
                      <ListItemIcon>{filter.icon}</ListItemIcon>
                      <ListItemText primary={filter.label} />
                    </MenuItem>
                  ))}

              {category === "people" && (
                <>
                  <MenuItem disableRipple>
                    <Box display="flex" alignItems="center" width="100%">
                      <SearchIcon sx={{ mr: 1 }} />
                      <input
                        type="text"
                        placeholder="Search people"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        style={{
                          border: "none",
                          outline: "none",
                          background: "transparent",
                          color: "white",
                          width: "100%",
                        }}
                      />
                    </Box>
                  </MenuItem>

                  {filteredPeople.map((person) => (
                    <MenuItem
                      key={person._id}
                      onClick={(e) => handlePersonClick(e, person)}
                    >
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        width="100%"
                        gap="1rem"
                      >
                        <AccountCircle
                          style={{ fontSize: 30, color: "gray" }}
                        />
                        <Box>
                          <Typography variant="body1">
                            {person.firstName} {person.lastName}
                          </Typography>
                          <Typography
                            variant="body2"
                            color="textSecondary"
                            whiteSpace="nowrap"
                            width="10rem"
                            overflow="hidden"
                            textOverflow="ellipsis"
                          >
                            {person.email}
                          </Typography>
                        </Box>
                        <ArrowRightIcon />
                      </Box>
                    </MenuItem>
                  ))}

                  <MenuItem onClick={onClickPeopleFilterAnyoneWithLink}>
                    <Box display="flex" alignItems="center" gap="1rem">
                      <PeopleAltRoundedIcon />
                      <Typography>Anyone with Link</Typography>
                    </Box>
                  </MenuItem>
                </>
              )}
            </Menu>

            {/* Submenu for people */}
            <Menu
              anchorEl={personSubmenuAnchorEl}
              open={Boolean(personSubmenuAnchorEl)}
              onClose={handleSubmenuClose}
              anchorOrigin={{ vertical: "top", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "left" }}
            >
              {[
                "Viewer",
                "Editor",
                //  "Commenter", "Owner",
                "Shared With",
              ].map((option) => (
                <MenuItem
                  key={option}
                  onClick={() => {
                    onClickPeopleAccessOption(option);
                  }}
                >
                  {option}
                </MenuItem>
              ))}
            </Menu>
          </Box>
        ))}

        {/* is space 80 full then show this box */}
        {!isLoading && isSpaceFull80ModalOpen && isSpaceFull80 && (
          <Box
            sx={{
              width: "100%",
              bgcolor: mode === "dark" ? "#121212" : "#D32F2F",
              color: "#ffffff",
              p: 4,
              borderRadius: 2,
              boxShadow: 24,
              height: "auto",
              marginLeft: "1rem",
              marginTop: "1rem",
              position: "relative", // Add this to position the close button
            }}
          >
            {/* Close Button */}
            <IconButton
              onClick={() => setIsSpaceFull80ModalOpen(false)}
              sx={{
                position: "absolute",
                top: 8,
                right: 8,
                color: "#fff",
              }}
            >
              <CloseIcon />
            </IconButton>

            <Stack direction="row" spacing={2} alignItems="flex-start">
              <WarningAmberRoundedIcon
                sx={{ fontSize: 64, mt: 0.5, color: "#FFD600" }}
              />
              <Box flex={1}>
                <Typography sx={{ mt: 1, color: "#fff" }}>
                  <strong>Storage Full:</strong>{" "}
                  {isUnlimited ? (
                    "You are on an unlimited storage plan. This alert shouldn't appear. Please contact support."
                  ) : (
                    <>
                      Your storage is full. You’ve used all of your{" "}
                      {noOfAllowed}
                      {format} individual storage. To upload more files, free up
                      space or talk to your administrator.
                    </>
                  )}
                </Typography>

                <Stack
                  direction="row"
                  spacing={2}
                  justifyContent="flex-end"
                  sx={{ mt: 3 }}
                >
                  <Button
                    variant="contained"
                    sx={{
                      backgroundColor: "#fddddd",
                      color: "#D32F2F",
                      "&:hover": {
                        backgroundColor: "#b71c1c",
                        color: "#ffffff",
                      },
                    }}
                    onClick={handleBuyStorage}
                  >
                    Buy Storage
                  </Button>
                </Stack>
              </Box>
            </Stack>
          </Box>
        )}
      </Box>
    </>
  );
};

export default Filters;
